export default __webpack_public_path__ + "static/media/layers-half.3b7a23b0.svg";